var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-max-w-7xl tw-mx-auto tw-m-8"},[_c('middleman-card',{attrs:{"loading":_vm.loading,"middleman":_vm.middleman},on:{"updated":_vm.onEdit,"removed":_vm.onDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }